import * as React from 'react';

import type { Stock } from '../../../output/models';

import { StockRow } from './StockRow';
import { TableHeader } from './TableHeader';

interface Props {
  stocks: Stock[];
}

export const StockTable: React.FC<Props> = ({ stocks }) => {
  return (
    <table className="row-striped w-[490px] text-xs leading-base">
      <TableHeader />
      <tbody>
        {stocks.map((stock, index) => (
          <StockRow stock={stock} key={index} />
        ))}
      </tbody>
    </table>
  );
};
